import $ from 'jQuery';

export default function () {
	'use strict';

	const debug = false;
	const accordionButton = $('.accordion__button');
	const accordionExpander = $('.basic-accordion__expand-all');

	function toggleAccordion($element) {
		const accordionId = $element.attr('data-attr');
		$element.toggleClass('active');
		$element.parents('.accordion').toggleClass('accordion__active');
		$(`#accordion-${accordionId}`).slideToggle();
		$('.accordion__icon', $element).toggleClass('active');
	}

	function accordionButtonClicked() {
		debug ? console.log('... Accordion button CLICKED') : null;
		toggleAccordion($(this));
	}

	function accordionButtonExpanderClicked() {
		debug ? console.log('... Accordion expander button CLICKED') : null;

		const $this = $(this);
		const action = $this.attr('data-action');
		$this.attr('data-action', action === 'expand' ? 'collapse' : 'expand');
		$this.html(action === 'expand' ? $this.attr('data-text-collapse') : $this.attr('data-text-expand'));

		accordionButton.each(function () {
			const $button = $(this);
			const isActive = $button.hasClass('active');
			if ((action === 'expand' && !isActive) || (action === 'collapse' && isActive)) {
				toggleAccordion($button);
			}
		});
	}

	if (accordionExpander) {
		debug ? console.log('... Accordion expander button(s) FOUND') : null;
		accordionExpander.click(accordionButtonExpanderClicked);
	}

	if (accordionButton) {
		debug ? console.log('... Accordion button(s) FOUND') : null;
		accordionButton.click(accordionButtonClicked);
	}
}
